var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlusIcon(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.3335 5.66683H1.00016C0.811274 5.66683 0.652941 5.60294 0.525163 5.47516C0.397385 5.34739 0.333496 5.18905 0.333496 5.00016C0.333496 4.81127 0.397385 4.65294 0.525163 4.52516C0.652941 4.39739 0.811274 4.3335 1.00016 4.3335H4.3335V1.00016C4.3335 0.811274 4.39739 0.652941 4.52516 0.525163C4.65294 0.397385 4.81127 0.333496 5.00016 0.333496C5.18905 0.333496 5.34739 0.397385 5.47516 0.525163C5.60294 0.652941 5.66683 0.811274 5.66683 1.00016V4.3335H9.00016C9.18905 4.3335 9.34739 4.39739 9.47516 4.52516C9.60294 4.65294 9.66683 4.81127 9.66683 5.00016C9.66683 5.18905 9.60294 5.34739 9.47516 5.47516C9.34739 5.60294 9.18905 5.66683 9.00016 5.66683H5.66683V9.00016C5.66683 9.18905 5.60294 9.34739 5.47516 9.47516C5.34739 9.60294 5.18905 9.66683 5.00016 9.66683C4.81127 9.66683 4.65294 9.60294 4.52516 9.47516C4.39739 9.34739 4.3335 9.18905 4.3335 9.00016V5.66683Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plus-icon.149b108c.svg";
export { ForwardRef as ReactComponent };